export const name = 'siteAboveTheFoldService' as const
export const SITE_SERVICE_PACKAGE_NAME = '@wix/site-service-above-the-fold' as const
